'use es6';

export const HSPB_LOADED = '_hspb_loaded';
export const HSPB_RAN = '_hspb_ran';
export const HSP_QUEUE_NAME = '_hsp';
export const HSQ_QUEUE_NAME = '_hsq';
export const PRIVACY_TESTING_FLAG = '_hsPrivacyTest';
export const GEO_TARGETING_TEST_FLAG = '_hsGeoTargetingTest';
export const SCANNING_MODE_FLAG = '_hsScanningMode';
const EU_ISO_CODES = ['AT',
// "Austria",
'BE',
// "Belgium",
'BG',
// "Bulgaria",
'HR',
// "Croatia",
'CY',
// "Cyprus",
'CZ',
// "Czech Republic",
'DK',
// "Denmark",
'EE',
// "Estonia",
'FI',
// "Finland",
'FR',
// "France",
'DE',
// "Germany",
'GR',
// "Greece",
'HU',
// "Hungary",
'IE',
// "Ireland, Republic of (EIRE)",
'IT',
// "Italy",
'LV',
// "Latvia",
'LT',
// "Lithuania",
'LU',
// "Luxembourg",
'MT',
// "Malta",
'NL',
// "Netherlands",
'PL',
// "Poland",
'PT',
// "Portugal",
'RO',
//"Romania",
'SK',
// "Slovakia",
'SI',
// "Slovenia",
'ES',
// "Spain",
'SE' // "Sweden",
];
export const EFTA_ISO_CODES = ['IS',
// Iceland
'LI',
// Liechtenstein
'NO' // Norway
];
export const EEA_ISO_CODES = [...EU_ISO_CODES, ...EFTA_ISO_CODES, 'GB' // United Kingdom of Great Britain
];